import {Field} from "formik";
import PropTypes from "prop-types";
import React from "react";
import {RequiredAstrix} from "./FormElements";

function CheckboxField({name, label, value, required}) {
    return (
        <Field name={name}>
            {({field, form}) => (
                <label>
                    <input
                        {...field}
                        type="checkbox"
                        name={name}
                        onChange={() => form.setFieldValue(name, !value)}
                        checked={value}
                    />
                    <span className='checkbox-custom'/>
                    <label className={'custom-checkbox'}>{label} {required && <RequiredAstrix />}</label>
                </label>
            )}
        </Field>
    )
}

CheckboxField.propTypes = {
    name: PropTypes.string,
    value: PropTypes.bool
}

export default CheckboxField;
